import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cardTitle: 'Tax domicile',
    cardTitleSecond: 'Other tax domicile',
    countryLabel: 'Select a country',
    countryPlaceholder: 'Select country...',
    deleteButton: 'Delete',
    helpDescription:
      'Your tax domicile is in France if you meet one of the following criteria:\n' +
      'France is the place of your main stay, that is to say you stay there for more than 6 months during the year\n' +
      'Your main activity is in France. The main activity is the one to which you devote the most effective time or the one which provides you with the majority of your income. If you carry out several activities, it is the main activity which is taken into account. An activity carried out incidentally is not concerned.\n' +
      'You have made your main investments in France.\n',
    helpTitle: 'How do I know if my tax domicile is in France?\n',
    nextButtonLabel: 'Confirm my details\n',
    taxIdentificationNumberDescription:
      'I have a tax reference number and I certify that my TIN is as follows',
    taxIdentificationNumberInvalidFormat: 'This TIN is incorrect.',
    taxIdentificationNumberLabel: 'Tax Identification Number',
    title: 'Declare your tax domicile',
  },
  fr: {
    cardTitle: 'Domicile fiscal',
    cardTitleSecond: 'Autre domicile fiscal',
    countryLabel: 'Sélectionnez un pays',
    countryPlaceholder: 'Sélectionner le pays...',
    deleteButton: 'Supprimer',
    helpDescription:
      'Votre domicile fiscal est en France si vous remplissez l’un des critères suivants :\n' +
      'La France est le lieu de votre séjour principal, c’est-à-dire que vous y séjournez plus de 6 mois au cours de l’année\n' +
      'Votre activité principale est en France. L’activité principale est celle à laquelle vous consacrez le plus de temps effectif ou celle qui vous procure l’essentiel de vos revenus. Si vous exercez plusieurs activités, c’est l’activité principale qui est prise en compte. Une activité exercée de façon accessoire n’est pas concernée.\n' +
      'Vous avez effectué vos principaux investissements en France.',
    helpTitle: 'Comment déterminer si mon domicile fiscal est en France\u00A0?',
    nextButtonLabel: 'Confirmer mes informations',
    taxIdentificationNumberDescription:
      'Je dispose d’un numéro fiscal de référence et je certifie que mon NIF est le suivant',
    taxIdentificationNumberInvalidFormat:
      'Ce numéro d’identification fiscale est incorrect',
    taxIdentificationNumberLabel: 'Numéro d’Identification Fiscale',
    title: 'Déclarez votre domicile fiscal',
  },
} as const);

export default locales;
